"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cs = _interopRequireDefault(require("highlight.js/lib/languages/cs"));

var _default = _cs.default;
exports.default = _default;